module.exports = __webpack_public_path__ + "static/media/eStore-hero-moneyProcessing1.2358aaa6.png";